import type { FiltersGroups } from '@/app/common/filters/core/filtersTypes.ts';
import type { FilterSessionState } from '@/app/common/filters/session/sessionState.ts';
import { selectedValuesByGroup } from '@/app/common/filters/session/selectedValues.ts';

export type FilterOrder = {
  groups: string[];
  options: Record<string, string[]>;
};

export const EMPTY_FILTER_ORDER: FilterOrder = { groups: [], options: {} };

const withLeaderFirst = (values: string[], leader?: string): string[] =>
  leader && values.includes(leader) ? [leader, ...values.filter((value) => value !== leader)] : values;

export const deriveFilterOrder = (state: FilterSessionState, filtersGroups: FiltersGroups): FilterOrder => {
  const live = selectedValuesByGroup(filtersGroups);
  const stored = state.entries.filter((entry) => !!live[entry.groupId]);

  const options = Object.fromEntries(
    Object.entries(live).map(([groupId, values]) => [
      groupId,
      withLeaderFirst(values, stored.find((entry) => entry.groupId === groupId)?.leader),
    ])
  );

  return { groups: stored.map((entry) => entry.groupId), options };
};
